import { Stickyheader } from "./stickyheader";


export class Header {
    constructor() {
        this.init();
    }

    init() {
        const header = $('#header');

        if (!header.length) {
            return;
        }

        new Stickyheader(header);
    }
}
